const module = {
  firestorePath: 'categories',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'category',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      parentId: '',
      iconUrl: '',
      bannerUrl: '',
      backgroundColor: '',
      nameId: '',
      nameEn: '',
      titleId: '',
      titleEn: '',
      descriptionId: '',
      descriptionEn: '',
      tags: [],
      topLevel: '',
      isDeleted: ''
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    arrayData: state => Object.values(state.data),
    arrayParent: (state, getters) => getters.arrayData.filter(i => (i.topLevel === true)),
  },
  mutations: {},
  actions: {},
}

export default module
